export default __webpack_public_path__ + "static/media/lucach.1ab7e8cc.png";